import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { LobI } from 'src/app/interfaces/lob.interface';
import { months } from 'src/app/interfaces/month.array';
import { SectorI } from 'src/app/interfaces/segment-sector.interface';
import { LobKm } from '../models/lob.model';
import { UserI } from 'src/app/interfaces/user.interface';

@Component({
  selector: 'app-rows',
  templateUrl: './rows.component.html',
  styleUrls: ['./rows.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RowComponent {
  //* Aca pasamos el tipo de dato en la carga
  @Input() tipo!: string;
  @Input() lobs!: LobI[];
  @Input() user!: UserI | null;
  @Input() index!: number;

  hasError = false;
  showError() {
    this.hasError = true;
    this.cd.detectChanges();
  }

  @Input() lob!: LobKm;

  constructor(private cd: ChangeDetectorRef) {}

  ngOnInit() {
    //* Seteamos los valores de los selectedLob
    this.lob.selectedLob = this.lobs.find(
      (l) => l.other_names?.includes(this.lob.lob) || l.name == this.lob.lob
    )!;
    //* Recorremos sus sectores
    this.lob.sector.forEach((s) => {
      //* Para setear el valor del selectedSector
      s.selectedSector = this.lob.selectedLob?.sector?.find(
        (ls) => ls.name == s.nombre
      );
    });

    if (this.lob.sector.length > 0) {
      this.sumarCantidades();
    }

    this.setSectors();
  }

  /** En la lob seleccionada, setea un valor llamado 'Otro' */
  setSectors() {
    if (
      this.lob.selectedLob
        ? !this.lob.selectedLob?.sector?.map((s) => s.id).includes('otro')
        : false
    )
      this.lob.selectedLob?.sector?.push({
        id: 'otro',
        name: 'Otro',
        segment: [],
      });
  }

  /** Obtiene los meses del año */
  meses = months;

  trackByIndex(index: number, item: any): number {
    return index;
  }

  /** Modelo del modal */
  visible = false;
  /** Mensaje de error */
  error = false;
  /** Index seleccionado */
  i = 0;
  /** Abre el modal para agregar un nuevo sector, pasa el index del dropdown seleccionado */
  openModal(sector: SectorI | undefined, i: number) {
    if (sector) {
      this.visible = sector.name === 'Otro';
      this.i = i;
    }
  }
  /** Agrega un nuevo sector a la lob */
  setNewSector(value: string) {
    if (value) {
      //* Evitamos registros repetidos
      const s = this.lob.selectedLob?.sector?.find(
        (s) => s.name.toLowerCase() == value.toLowerCase()
      );
      if (!s)
        this.lob.selectedLob?.sector?.unshift({
          name: value,
          segment: [],
          lob: [{ id: this.lob.selectedLob?.id }],
          visible: false,
          upload_user: { id: this.user!.id },
          ediciones: [
            {
              descripcion: 'Carga desde Km Shell',
              usuario: { id: this.user?.id! },
            },
          ],
        });
      this.lob.sector[this.i].selectedSector = s
        ? s
        : this.lob.selectedLob?.sector![0];
      this.visible = false;
    } else {
      //* Muestra el mensaje error
      this.error = true;
    }
  }

  /** Controla que el sector no quede con el agregado: 'Otro' */
  checkSector() {
    const s = this.lob.sector[this.i];
    if (s?.selectedSector?.name == 'Otro') s.selectedSector = undefined;
  }

  // Borra rows de la planilla ------------------------->
  @Output() delete = new EventEmitter<{ index: number; tipo: string }>();
  onDelete() {
    this.delete.emit({ index: this.index, tipo: this.tipo });
  }

  deleteSector(i: number) {
    this.lob.sector.splice(i, 1);
  }
  // Borra rows de la planilla ------------------------->

  // Añade rows en la planilla ------------------------->
  addSector() {
    this.lob.sector.push({
      nombre: '',
      cantidades: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      selectedSector: undefined,
    });
  }
  // Añade rows en la planilla ------------------------->

  sumarCantidades() {
    const arrays = this.lob.sector.map((s) => s.cantidades);
    const result = arrays.reduce((acc, curr) =>
      acc.map((num, i) => num + curr[i])
    );
    this.lob.cantidades = result;
  }
}
